import { SchoolLocation } from "../dashboard/schoolLocation.model";
//import {environment} from "../../environments/environment.uat";
import {environment} from "../../environments/environment";

export const RealSchoolLocations: SchoolLocation[] = [
    {
        "SchoolName": "Alcova Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Dacula",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Alford Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Discovery",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Anderson-Livsey Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Annistown Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Arcado Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Parkview",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Archer High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Archer",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Baggett Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Discovery",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Baldwin Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Bay Creek Middle School",
        "CityAndState": "Grayson, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.8933,
        "Lng": -83.9554
    },
    {
        "SchoolName": "Beaver Ridge Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Benefield Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Discovery",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Berkeley Lake Elementary School",
        "CityAndState": "Berkeley Lake, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 33.9853,
        "Lng": -84.1833
    },
    {
        "SchoolName": "Berkmar High School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Berkmar Middle School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Bethesda Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Britt Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Brookwood Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Brookwood High School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Buice Center - ADAPT",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Buice Center - STRIVE",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Buice Center - The BRIDGE",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Burnette Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Camp Creek Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Parkview",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Cedar Hill Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Discovery",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Centerville Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Central Gwinnett High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Chattahoochee Elementary School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Chesney Elementary School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Coleman Middle School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Collins Hill High School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "Collins Hill",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Cooper Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Archer",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Corley Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Couch Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Craig Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Creekland Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Collins Hill",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Crews Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Dacula Elementary School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Dacula",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Dacula High School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Dacula",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Dacula Middle School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Dacula",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Discovery High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Discovery",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Duluth High School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Duluth Middle School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Duncan Creek Elementary School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Mill Creek",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Dyer Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "Mountain View",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Ferguson Elementary School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Five Forks Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Fort Daniel Elementary School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Mill Creek",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Freeman's Mill Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Mountain View",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "GIVE Center East",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "GIVE Center West",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Grace Snell Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Graves Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Grayson Elementary School",
        "CityAndState": "Grayson, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.8933,
        "Lng": -83.9554
    },
    {
        "SchoolName": "Grayson High School",
        "CityAndState": "Loganville, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.839,
        "Lng": -83.9007
    },
    {
        "SchoolName": "Gwin Oaks Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Gwinnett Online Campus",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Gwinnett School of Mathematics, Science, and Technology",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Harbins Elementary School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Archer",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Harmony Elementary School",
        "CityAndState": "Monroe, GA",
        "County": "Gwinnett",
        "Cluster": "Seckinger",
        "Lat": 33.7948,
        "Lng": -83.7132
    },
    {
        "SchoolName": "Harris Elementary School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Duluth",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Head Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Brookwood",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Hopkins Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Hull Middle School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "International Transition Center",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Ivy Creek Elementary School",
        "CityAndState": "Buford, GA",
        "County": "Gwinnett",
        "Cluster": "Seckinger",
        "Lat": 34.1207,
        "Lng": -84.0044
    },
    {
        "SchoolName": "Jackson Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Jenkins Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Jones Middle School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Seckinger",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Jordan Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Kanoheda Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Knight Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Parkview",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Lanier High School",
        "CityAndState": "Sugar Hill, GA",
        "County": "Gwinnett",
        "Cluster": "Lanier",
        "Lat": 34.1065,
        "Lng": -84.0335
    },
    {
        "SchoolName": "Lanier Middle School",
        "CityAndState": "Sugar Hill, GA",
        "County": "Gwinnett",
        "Cluster": "Lanier",
        "Lat": 34.1065,
        "Lng": -84.0335
    },
    {
        "SchoolName": "Lawrenceville Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Level Creek Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "North Gwinnett",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Lilburn Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Lilburn Middle School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Lovin Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Archer",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Magill Elementary School",
        "CityAndState": "Loganville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.839,
        "Lng": -83.9007
    },
    {
        "SchoolName": "Mason Elementary School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Maxwell High School of Technology",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "McClure Health Science High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "McConnell Middle School",
        "CityAndState": "Loganville, GA",
        "County": "Gwinnett",
        "Cluster": "Archer",
        "Lat": 33.839,
        "Lng": -83.9007
    },
    {
        "SchoolName": "McKendree Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Collins Hill",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Meadowcreek Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Meadowcreek High School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Mill Creek High School",
        "CityAndState": "Hoschton, GA",
        "County": "Gwinnett",
        "Cluster": "Mill Creek",
        "Lat": 34.0965,
        "Lng": -83.6713
    },
    {
        "SchoolName": "Minor Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Moore Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Mountain Park Elementary School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Parkview",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Mountain View High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Mountain View",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Mulberry Elementary School",
        "CityAndState": "Auburn, GA",
        "County": "Gwinnett",
        "Cluster": "Dacula",
        "Lat": 34.0137,
        "Lng": -83.8277
    },
    {
        "SchoolName": "Nesbit Elementary School",
        "CityAndState": "Tucker, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.8545,
        "Lng": -84.2171
    },
    {
        "SchoolName": "New Life Academy of Excellence Inc.",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Norcross Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Norcross High School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "North Gwinnett High School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "North Gwinnett",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "North Gwinnett Middle School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "North Gwinnett",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "North Metro Academy of Performing Arts",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Northbrook Middle School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Norton Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Oakland Meadow School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Osborne Middle School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Mill Creek",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Parkview High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Parkview",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Parsons Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Partee Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Patrick Elementary School",
        "CityAndState": "Buford, GA",
        "County": "Gwinnett",
        "Cluster": "Seckinger",
        "Lat": 34.1207,
        "Lng": -84.0044
    },
    {
        "SchoolName": "Paul Duke STEM High School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Peachtree Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Peachtree Ridge High School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Peachtree Ridge",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Pharr Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Phoenix High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Other",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Pinckneyville Middle School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Puckett's Mill Elementary School",
        "CityAndState": "Dacula, GA",
        "County": "Gwinnett",
        "Cluster": "Mill Creek",
        "Lat": 33.9887,
        "Lng": -83.898
    },
    {
        "SchoolName": "Radloff Middle School",
        "CityAndState": "Duluth, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 34.0029,
        "Lng": -84.1446
    },
    {
        "SchoolName": "Richards Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Discovery",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Riverside Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "North Gwinnett",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Roberts Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "North Gwinnett",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Rock Springs Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Collins Hill",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Rockbridge Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Meadowcreek",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Rosebud Elementary School",
        "CityAndState": "Loganville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.839,
        "Lng": -83.9007
    },
    {
        "SchoolName": "Seckinger High School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Seckinger",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Shiloh Elementary School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Shiloh High School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Shiloh Middle School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "Shiloh",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Simonton Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Simpson Elementary School",
        "CityAndState": "Peachtree Corners, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9561,
        "Lng": -84.2322
    },
    {
        "SchoolName": "Snellville Middle School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "South Gwinnett High School",
        "CityAndState": "Snellville, GA",
        "County": "Gwinnett",
        "Cluster": "South Gwinnett",
        "Lat": 33.8573,
        "Lng": -84.0199
    },
    {
        "SchoolName": "Starling Elementary School",
        "CityAndState": "Grayson, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.8933,
        "Lng": -83.9554
    },
    {
        "SchoolName": "Stripling Elementary School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9411,
        "Lng": -84.2137
    },
    {
        "SchoolName": "Sugar Hill Elementary School",
        "CityAndState": "Sugar Hill, GA",
        "County": "Gwinnett",
        "Cluster": "Lanier",
        "Lat": 34.1065,
        "Lng": -84.0335
    },
    {
        "SchoolName": "Summerour Middle School",
        "CityAndState": "Norcross, GA",
        "County": "Gwinnett",
        "Cluster": "Norcross",
        "Lat": 33.9412,
        "Lng": -84.2135
    },
    {
        "SchoolName": "Suwanee Elementary School",
        "CityAndState": "Suwanee, GA",
        "County": "Gwinnett",
        "Cluster": "North Gwinnett",
        "Lat": 34.0515,
        "Lng": -84.0713
    },
    {
        "SchoolName": "Sweetwater Middle School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Berkmar",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Sycamore Elementary School",
        "CityAndState": "Sugar Hill, GA",
        "County": "Gwinnett",
        "Cluster": "Lanier",
        "Lat": 34.1065,
        "Lng": -84.0335
    },
    {
        "SchoolName": "Taylor Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Collins Hill",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Trickum Middle School",
        "CityAndState": "Lilburn, GA",
        "County": "Gwinnett",
        "Cluster": "Parkview",
        "Lat": 33.8901,
        "Lng": -84.142975
    },
    {
        "SchoolName": "Trip Elementary School",
        "CityAndState": "Grayson, GA",
        "County": "Gwinnett",
        "Cluster": "Grayson",
        "Lat": 33.8933,
        "Lng": -83.9554
    },
    {
        "SchoolName": "Twin Rivers Middle School",
        "CityAndState": "Buford, GA",
        "County": "Gwinnett",
        "Cluster": "Mountain View",
        "Lat": 34.1207,
        "Lng": -84.0044
    },
    {
        "SchoolName": "Walnut Grove Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Collins Hill",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "White Oak Elementary School",
        "CityAndState": "Sugar Hill, GA",
        "County": "Gwinnett",
        "Cluster": "Lanier",
        "Lat": 34.1065,
        "Lng": -84.0335
    },
    {
        "SchoolName": "Winn Holt Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Central Gwinnett",
        "Lat": 33.9508,
        "Lng": -83.9876
    },
    {
        "SchoolName": "Woodward Mill Elementary School",
        "CityAndState": "Lawrenceville, GA",
        "County": "Gwinnett",
        "Cluster": "Mountain View",
        "Lat": 33.9508,
        "Lng": -83.9876
    }
]

export const UATSchoolLocations: SchoolLocation[] = [
  { SchoolName: "C EM School", Cluster: "A Cluster", CityAndState: "Lawrenceville, GA", County: "Gwinnett", Lat: 33.9508, Lng: -83.9876 },
  { SchoolName: "L EM School", Cluster: "A Cluster", CityAndState: "Lawrenceville, GA", County: "Gwinnett", Lat: 33.9508, Lng: -83.9876 },
  { SchoolName: "B HS School", Cluster: "B Cluster", CityAndState: "Snellville, GA", County: "Gwinnett", Lat: 33.8573, Lng: -84.0199 },
  { SchoolName: "CL MS School", Cluster: "D Cluster", CityAndState: "Duluth, GA", County: "Gwinnett", Lat: 34.0029, Lng: -84.1446 },
  { SchoolName: "LL ES School", Cluster: "M Cluster", CityAndState: "Lilburn, GA", County: "Gwinnett", Lat: 33.8901, Lng: -84.142975 },
  { SchoolName: "T ES School", Cluster: "G Cluster", CityAndState: "Grayson, GA", County: "Gwinnett", Lat: 33.8933, Lng: -83.9554 },
  { SchoolName: "G HS School", Cluster: "G Cluster", CityAndState: "Loganville, GA", County: "Gwinnett", Lat: 33.839, Lng: -83.9007 },
  { SchoolName: "DS HS School", Cluster: "DS Cluster", CityAndState: "Lawrenceville, GA", County: "Gwinnett", Lat: 33.9508, Lng: -83.9876 },
  { SchoolName: "A HS School", Cluster: "A Cluster", CityAndState: "Lawrenceville, GA", County: "Gwinnett", Lat: 33.9508, Lng: -83.9876 }
];

// check to see which school data to use
export const SchoolLocations: SchoolLocation[] = environment.UAT ? UATSchoolLocations : RealSchoolLocations;
